module.exports = __webpack_public_path__ + "static/media/1009805.2b7b389f.jpg";